import { Component,Inject,OnInit,PLATFORM_ID,Renderer2,TemplateRef,ViewChild } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { FormGroup } from '@angular/forms';
import { FormBuilder,Validators } from '@angular/forms';
import { MainserviceService } from 'src/app/mainservice.service';
import Swal from 'sweetalert2';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import { MatDatepicker } from '@angular/material/datepicker';
import { Title, Meta } from '@angular/platform-browser';
import { JsonLdService, SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';
@Component({
  selector: 'app-generalagro',
  templateUrl: './generalagro.component.html',
  styleUrls: ['./generalagro.component.scss'],
  providers:[MainserviceService,DatePipe]
})
export class GeneralagroComponent {


  enquiryForm:FormGroup;
  totalcountry:any=[];
  captcha:any
  errorcaptcha:any
  ecaptcha:boolean=false;
  dialcode:any;
  showElement: boolean = false;
  showElementsave: boolean = false;
  @ViewChild('picker') picker!: MatDatepicker<Date>;
  @ViewChild('inputField') inputField!: any;
  currentTime: Date;
  timeSlots:any=[];
  timezone:any;
  appointment_time:boolean=false;
  selectedTime: string | null = null;
  leads:any;
constructor(private ngxsmartservice:NgxSmartModalService,private fb:FormBuilder,private seoService: SeoSocialShareService,private jsonLdService: JsonLdService,
  private mainservice:MainserviceService,private datePipe: DatePipe,private title:Title,private meta:Meta,private renderer: Renderer2,@Inject(PLATFORM_ID) private platformId: Object){
    if (isPlatformBrowser(this.platformId)) {
    this.setSeoMeta();
    this.setSchema();
    this.setFaqSchemaData();
    this.setWebsiteSchema();
  // this.title.setTitle('Grow Your Agro Business with Medeilcloud POS Software');

  // // Add meta tags dynamically
  // this.meta.addTag({name: 'description', content: 'Optimize operations, increase ROI. Automate processes for success. Streamline agro, pesticide, and dairy operations. Maximize efficiency today!'  });
  // this.meta.addTag({ name: 'keywords', content: 'agriculture software, farming software, agro store software, dairy product software, agro management software' });
  this.timezone=sessionStorage.getItem('timezone');
  this.enquiryForm=this.fb.group({
      leadname: ['',[ Validators.required]],
      organizationname: ['',[Validators.required]],
      leadsourceid: ['',[]],
      leadsource: ['medeil website',[]],
      sourceRef1: ['',[]],
      sourceRef2: ['',[]],
      description: ['',[ Validators.required]],
      primaryphone: ['',[Validators.required]],
      primaryemail: ['',[Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')]],
      address1: ['',[]],
      address2: ['',[]],
      country: [sessionStorage.getItem('country'),[],[]],
      countryname1: ['0',[]],
      state: [sessionStorage.getItem('state'),[]],
      city: [sessionStorage.getItem('city'),[]],
      enteredcaptcha: ['',[]],
      generatedcaptcha: ['',[]],
      phonedialcode:['',[]],
      checkbox:[false,[]],
      appfrmtime:['',[]],
      apptotime:['',[]],
      appointmentdate:['',[]],
    })
  }
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
    this.mainservice.generatecaptcha();
    this.captcha = localStorage.getItem('captcha')
     // ----country list--
     this.mainservice.getCountryList().subscribe(data=>{
       console.log(data);
       this.totalcountry=data;
     })
    }
  }
  // setSeoMeta() {
  //   const seoData: SeoSocialShareData = {
  //     title: 'Agro Store Software | Efficient Management for Agricultural Retail',
  //     description: 'Optimize your agro store operations with Medeil\'s software. Manage seeds, fertilizers, and equipment inventory with ease.',
  //     image: 'https://www.medeil.com/assets/agro-store-software.jpg',
  //     url: 'https://www.medeil.com/agro-store-software',
  //     keywords: 'Agro store software, agricultural retail management, agro inventory software, agro POS system, farm store software'
  //   };

  //   this.seoService.setData(seoData);
  // }

  // setSchema() {
  //   const schemaData = {
  //     "@context": "https://schema.org",
  //     "@type": "SoftwareApplication",
  //     "name": "Agro Store Software",
  //     "url": "https://www.medeil.com/agro-store-software",
  //     "description": "Optimize your agro store operations with Medeil's software. Manage seeds, fertilizers, and equipment inventory with ease.",
  //     "applicationCategory": "BusinessApplication",
  //     "operatingSystem": "Cloud-based (Web, Windows, macOS, Linux)",
  //     "image": "https://www.medeil.com/assets/agro-store-software.jpg",
  //     "offers": {
  //       "@type": "Offer",
  //       "priceCurrency": "USD",
  //       "availability": "https://schema.org/InStock",
  //       "url": "https://www.medeil.com/agro-store-software",
  //       "keywords": "Agro store software, agricultural retail management, agro inventory software, agro POS system, farm store software"
  //     },
  //     "aggregateRating": {
  //       "@type": "AggregateRating",
  //       "ratingValue": "4.6",
  //       "ratingCount": "8864"
  //     },
  //   };

  //   this.jsonLdService.setData(schemaData);
  // }
  // setWebsiteSchema() {
  //   const schemaData = {
  //     "@context": "https://schema.org",
  //     "@type": "WebSite",
  //     "name": "Agro Store Software",
  //     "url": "https://www.medeil.com",
  //     "description": "Optimize your agro store operations with Medeil's software. Manage seeds, fertilizers, and equipment inventory with ease.",
  //     "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
  //     "publisher": {
  //       "@type": "Organization",
  //       "name": "Medeil",
  //       "url": "https://www.medeil.com",
  //       "logo": {
  //         "@type": "ImageObject",
  //         "url": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
  //       }
  //     },
  //   };

  //   this.jsonLdService.setData(schemaData);
  // }
  // setFaqSchemaData() {
  //   const faqSchema = {
  //     "@context": "https://schema.org",
  //     "@type": "FAQPage",
  //     "mainEntity": [
  //       {
  //         "@type": "Question",
  //         "name": "How does your software support precision agriculture and variable rate application techniques?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "This question pertains to the software's functionalities for implementing precision agriculture practices, such as variable rate seeding, fertilization, and irrigation. Responses may include precision mapping tools, prescription generation algorithms, and equipment integration capabilities that enable precise input application based on spatial and temporal variability in the field."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "How does the agricultural value chain's stakeholders' cooperation and data exchange become supported by your farm software?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "This inquiry focuses on how well the software can help farmers, agronomists, suppliers, distributors, and other stakeholders collaborate, communicate, and share data. In order to facilitate smooth communication and cooperation throughout the agricultural ecosystem, possible solutions include cloud-based collaboration platforms, data exchange standards, and API connections."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "Which are the sub vertical in agriculture software space do you support?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "We support manufacturer, distribution, retailing for agro finished products, pesticide & insecticide stores, fertilizer shop, dairy industries, etc."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "Is it possible for your program to offer documents related to compliance and traceability for food safety and regulatory requirements?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "This inquiry concerns the software's ability to trace agricultural products' origin, manufacturing method, and distribution in order to guarantee food safety and legal compliance. Features that assist farmers in adhering to industry norms and regulatory obligations, such as batch traceability, audit trails, and compliance reporting capabilities, may be included in the response."
  //         }
  //       }
  //     ]
  //   };

  //   this.addJsonLdToHead(faqSchema);
  // }


//   setSeoMeta() {
//   const seoData: SeoSocialShareData = {
//     title: $localize`:@@AGRO_STORE_SOFTWARE.TITLE:Agro Store Software | Efficient Management for Agricultural Retail`,
//     description: $localize`:@@AGRO_STORE_SOFTWARE.DESCRIPTION:Optimize your agro store operations with Medeil's software. Manage seeds, fertilizers, and equipment inventory with ease.`,
//     image: 'https://www.medeil.com/assets/agro-store-software.jpg',
//     url: 'https://www.medeil.com/agro-store-software',
//     keywords: $localize`:@@AGRO_STORE_SOFTWARE.KEYWORDS:Agro store software, agricultural retail management, agro inventory software, agro POS system, farm store software`
//   };

//   this.seoService.setData(seoData);
// }
setSeoMeta() {
 const supportedLanguages = ['en', 'fr', 'es', 'pt'];
  let finalUrl = '';

  if (isPlatformBrowser(this.platformId)) {
    const origin = window.location.origin;
    const path = window.location.pathname;
    const parts = path.split('/');

    let lang = 'en'; // Default
    if (supportedLanguages.includes(parts[1])) {
      lang = parts[1];
    }

    // const fullPath = path.replace(/^\/[a-z]{2}/, '');
    // finalUrl = `${origin}/${lang}${fullPath}`;
    const fullPath = path.replace(/^\/[a-z]{2}/, '').replace(/\/+$/, ''); // remove trailing slash
finalUrl = `${origin}/${lang}${fullPath ? '/' + fullPath : ''}`;

  }

  const seoData = {
    title: $localize`:@@AGRO_STORE_SOFTWARE.TITLE:Agro Store Software | Simplify Agri Retail`,
    description:$localize`:@@AGRO_STORE_SOFTWARE.DESCRIPTION:Optimize your agro store operations with Medeil's software. Manage seeds, fertilizers, and equipment inventory with ease.`,
    image: 'https://www.medeil.com/en/assets/agro-store-software.jpg',
    url: finalUrl,
    keywords: $localize`:@@AGRO_STORE_SOFTWARE.KEYWORDS:Agro store software, agricultural retail management, agro inventory software, agro POS system, farm store software`
  };

  this.title.setTitle(seoData.title);
    const metaTags = [
      { name: 'description', content: seoData.description },
      { name: 'keywords', content: seoData.keywords },
      { property: 'og:title', content: seoData.title },
      { property: 'og:description', content: seoData.description },
      { property: 'og:url', content: seoData.url },
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: seoData.image }
    ];

    metaTags.forEach(tag => this.meta.updateTag(tag));
}

setSchema() {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": $localize`:@@AGRO_STORE_SOFTWARE.SCHEMA_NAME:Agro Store Software`,
    "url": "https://www.medeil.com/agro-store-software",
    "description": $localize`:@@AGRO_STORE_SOFTWARE.SCHEMA_DESCRIPTION:Optimize your agro store operations with Medeil's software. Manage seeds, fertilizers, and equipment inventory with ease.`,
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Cloud-based (Web, Windows, macOS, Linux)",
    "image": "https://www.medeil.com/assets/agro-store-software.jpg",
    "offers": {
      "@type": "Offer",
      "priceCurrency": "USD",
      "availability": "https://schema.org/InStock",
      "url": "https://www.medeil.com/agro-store-software",
      "keywords": $localize`:@@AGRO_STORE_SOFTWARE.SCHEMA_KEYWORDS:Agro store software, agricultural retail management, agro inventory software, agro POS system, farm store software`
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.6",
      "ratingCount": "8864"
    }
  };

  this.jsonLdService.setData(schemaData);
}

setWebsiteSchema() {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": $localize`:@@AGRO_STORE_SOFTWARE.WEBSITE_NAME:Agro Store Software`,
    "url": "https://www.medeil.com",
    "description": $localize`:@@AGRO_STORE_SOFTWARE.WEBSITE_DESCRIPTION:Optimize your agro store operations with Medeil's software. Manage seeds, fertilizers, and equipment inventory with ease.`,
    "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
    "publisher": {
      "@type": "Organization",
      "name": "Medeil",
      "url": "https://www.medeil.com",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
      }
    }
  };

  this.jsonLdService.setData(schemaData);
}

setFaqSchemaData() {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": $localize`:@@AGRO_STORE_SOFTWARE.FAQ1_QUESTION:How does your software support precision agriculture and variable rate application techniques?`,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": $localize`:@@AGRO_STORE_SOFTWARE.FAQ1_ANSWER:This question pertains to the software's functionalities for implementing precision agriculture practices, such as variable rate seeding, fertilization, and irrigation.`
        }
      },
      {
        "@type": "Question",
        "name": $localize`:@@AGRO_STORE_SOFTWARE.FAQ2_QUESTION:How does the agricultural value chain's stakeholders' cooperation and data exchange become supported by your farm software?`,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": $localize`:@@AGRO_STORE_SOFTWARE.FAQ2_ANSWER:This inquiry focuses on how well the software can help farmers, agronomists, suppliers, distributors, and other stakeholders collaborate, communicate, and share data.`
        }
      },
      {
        "@type": "Question",
        "name": $localize`:@@AGRO_STORE_SOFTWARE.FAQ3_QUESTION:Which are the sub vertical in agriculture software space do you support?`,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": $localize`:@@AGRO_STORE_SOFTWARE.FAQ3_ANSWER:We support manufacturer, distribution, retailing for agro finished products, pesticide & insecticide stores, fertilizer shop, dairy industries, etc.`
        }
      },
      {
        "@type": "Question",
        "name": $localize`:@@AGRO_STORE_SOFTWARE.FAQ4_QUESTION:Is it possible for your program to offer documents related to compliance and traceability for food safety and regulatory requirements?`,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": $localize`:@@AGRO_STORE_SOFTWARE.FAQ4_ANSWER:This inquiry concerns the software's ability to trace agricultural products' origin, manufacturing method, and distribution in order to guarantee food safety and legal compliance.`
        }
      }
    ]
  };

  this.addJsonLdToHead(faqSchema);
}



  addJsonLdToHead(schema: any) {
    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    script.id = 'faq-schema';

    // Remove old schema if it exists
    const oldScript = document.getElementById('faq-schema');
    if (oldScript) {
      oldScript.remove();
    }

    this.renderer.appendChild(document.head, script);
  }
  countrychange(){

    this.mainservice.getMobileCode(this.enquiryForm.get('countryname1').value).subscribe((data)=>{
      //console.log(data);
      this.dialcode=data.Dailingcode;
      console.log(this.dialcode);
     // this.registerForm.get('phonedialcode').patchValue(this.dialcode[1]);
    })
  }
  checkCaptcha(){

    var usercaptcha = this.enquiryForm.get('enteredcaptcha').value

    if (this.captcha == usercaptcha) {
      this.ecaptcha = false

    } else {

      this.errorcaptcha = 'Enter correct Captcha'
      this.ecaptcha = true
    }
  }
  generatecaptcha(){
    this.mainservice.generatecaptcha()
    this.captcha = localStorage.getItem('captcha')
  }
  closeModal(): void {
    this.ngxsmartservice.close('enquirypos');
    this.ngxsmartservice.close('appointmentform');
    this.enquiryForm.reset();

    this.enquiryForm.get('countryname1').setValue('0');
    this.generatecaptcha();
  }
  validation(){
    let name=this.enquiryForm.get('leadname').value
    let organizationname=this.enquiryForm.get('organizationname').value
    let primaryemail=this.enquiryForm.get('primaryemail').value
    let primaryphone=this.enquiryForm.get('primaryphone').value
    let captcha=this.enquiryForm.get('enteredcaptcha').value
    let checkbox=this.enquiryForm.get('checkbox').value

    // var usercaptcha = this.registerForm.get('enteredcaptcha').value
    if(!name){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Name',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!organizationname){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Organization Name',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!primaryemail){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Your Email',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!primaryphone){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Your Mobile Number',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!captcha){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Captcha',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(captcha != this.captcha){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Correct Captcha',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(checkbox==false){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Select Accept & Terms condition',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }


    return true
  }
  slectdate(event: any){
    this.showElement=true;
    const selectedDate = event.value;
    const finalDate = this.datePipe.transform(selectedDate, 'yyyy-MM-dd');
    this.enquiryForm.get('appointmentdate').setValue(finalDate);
   this.currentTime = new Date();

   let map={
    "timezone":this.timezone,
    "orginaltimezone":this.currentTime
  }
  this.mainservice.gettimeSlots(map).subscribe(data=>{
    this.timeSlots = data[0].map((time:any)=> {
      const [hours, minutes] = time.split(':');
      const hours12 = ((parseInt(hours) + 11) % 12) + 1;
      const ampm = parseInt(hours) < 12 ? 'AM' : 'PM';
      return `${hours12}:${minutes} ${ampm}`;
    });
    this.showElement=false;
    console.log(this.timeSlots);
  })

    this.appointment_time=true;
  }
  selectTime(time: string): void {
    const currentTime = new Date();
    const formattedTime = this.datePipe.transform(currentTime, 'hh:mm:ss a');
    console.log(formattedTime);
    this.selectedTime = time;
    // this.enquiryForm.get('apptotime').setValue(time);
    this.enquiryForm.get('appfrmtime').setValue(time);

  }
  savelead(){
    this.showElementsave=true;



    // if (valid) {

      let phone = this.enquiryForm.get('primaryphone').value

      let mobileno=this.enquiryForm.get('phonedialcode').value+this.enquiryForm.get('primaryphone').value
      this.enquiryForm.get('primaryphone').setValue(mobileno)

       console.log('form',this.enquiryForm.value);

  this.mainservice.savelead(this.enquiryForm.value).subscribe((data: any) => {
    this.leads = data
    // console.log("this.leads",this.leads)
    if (data) {
      // this.enquiryForm.reset()
      // window.location.href= 'https://www.vanuston.com/thank-u-vanuston'
      this.enquiryForm.reset();
      this.showElementsave=false;
      // this.submitenquery();
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Data saved successfully',
        text: 'We will contact you shortly.',
        showConfirmButton: false,
        timer: 4000
      });
      this.ngxsmartservice.close('enquirypos');
      this.ngxsmartservice.close('appointmentform');
      this.enquiryForm.reset();
    }
     else{
      this.enquiryForm.get('primaryphone').setValue(phone);
      // this.showElement=false;
    }
    this.enquiryForm.get('countryname1').setValue('0');
    this.generatecaptcha();
  })

  }
  appointment(datasource:any){
    this.enquiryForm.get('sourceRef1').setValue(datasource);
    this.ngxsmartservice.open('enquirypos');
    // this.ngxsmartservice.open('appointmentform');

    this.enquiryForm.get('countryname1').setValue('0');
    this.generatecaptcha();
  }
  submitenquery(){
    let valid=this.validation();
    if(valid){
      this.ngxsmartservice.close('enquirypos');
      this.ngxsmartservice.open('appointmentform');
      this.picker.open();
      this.inputField.focus();
    }

  }
}
